import { facebookPixelPurchase } from '../../../api/funnel';

const safeWindow = () => /** @type {any} */ (window);

export const facebookProvider = {
  name: 'facebook',

  isAvailable() {
    return Boolean(safeWindow().fbq);
  },

  track(eventName, payload = {}, options = {}) {
    if (!this.isAvailable()) return;
    const { isCustom = false } = options;
    const method = isCustom ? 'trackCustom' : 'track';

    if (process.env.REACT_APP_ENV !== 'production') {
      console.log('[Tracking] Facebook', method, eventName, payload, options);
      return;
    }

    // Keep Facebook CAPI call close to FB provider logic.
    if (eventName === 'Purchase') {
      facebookPixelPurchase(payload.lead_code, payload.email, payload.selected_product, payload.eventId).catch(
        () => {}
      );
      return;
    }

    if (payload.event_id) {
      safeWindow().fbq(method, eventName, payload, { eventID: payload.eventId });
    } else {
      safeWindow().fbq(method, eventName, payload);
    }
  },
};
